import Vue from 'vue'
import router from '../../../router'
import moment from 'moment'

export const lotteryUsage = {
    state: {
        status: 'idle',
        lotteryUsage: null,
        pagination: {
            page: 1,
            totalPages: 0,
            perPage: 10,
            totalRecords: null
        },
        sort: {
            by: 'lottery.name',
            direction: 'desc'
        },
        sortOptions: [
            {
                query: 'lottery.name',
                label: 'Nazwa loterii'
            },
            {
                query: 'refund',
                label: 'Kwota refundacji'
            },
            {
                query: 'created_at',
                label: 'Data użycia'
            }
        ],

        filters: {
            advancedDisplay: {
                type: 'ui-checkbox-input',
                value: false,
                text: 'Widok zaawansowany'
            },
            startDate: {
                type: 'range-date',
                range: 'from',
                text: 'Od',
                title: 'Data',
                additionalText: 'Data od',
                groupName: 'range'
            },
            endDate: {
                type: 'range-date',
                range: 'to',
                text: 'Do',
                additionalText: 'Data do',
                groupName: 'range'
            },
            shopIds: {
                type: 'ui-virtual-list',
                value: null,
                searcher: false,
                label: 'Wybierz sklep',
                moduleName: 'merchants',
                fetchAction: 'merchantsFetch',
                getter: 'getMerchantsForSelect',
                disabledLinkGenerator: true
            }
        }
    },
    mutations: {
        SET_LOTTERYUSAGE_STATUS(state, payload) {
            state.status = payload
        },
        SET_LOTTERYUSAGE(state, payload) {
            state.lotteryUsage = payload
        },
        SET_LOTTERYUSAGE_TOTALPAGES(state, payload) {
            state.pagination.totalPages = payload
        },
        SET_LOTTERYUSAGE_TOTALRECORDS(state, payload) {
            state.pagination.totalRecords = payload
        },
        SET_LOTTERYUSAGE_CURRENT(state, payload) {
            state.pagination.page = payload
        },
        SET_LOTTERYUSAGE_PERPAGE(state, payload) {
            state.pagination.perPage = payload
        },
        SET_LOTTERYUSAGE_FILTER(state, payload) {
            Vue.set(state.filters[payload.filter], 'value', payload.value)
        },
        RESET_LOTTERYUSAGE_FILTERS(state, payload) {
            Vue.set(state, 'filters', payload)
        },
        SET_LOTTERYUSAGE_SORT(state, payload) {
            state.sort = payload
        }
    },
    actions: {
        async lotteryUsageFetch({ commit, state, getters }) {
            commit('SET_LOTTERYUSAGE_STATUS', 'loading')

            if (router.currentRoute.query.page) {
                commit(
                    'SET_LOTTERYUSAGE_CURRENT',
                    +router.currentRoute.query.page
                )
            }
            if (router.currentRoute.query.show) {
                commit(
                    'SET_LOTTERYUSAGE_PERPAGE',
                    +router.currentRoute.query.show
                )
            }

            const params = getters.getLotteryUsageQueryParams

            try {
                const res = await this.$api.post(
                    'reports/lotteryUsage?includes=lottery,merchant,transactions_log,merchant',
                    null,
                    { params }
                )

                const { totalPages, totalRecords } = res.data.pagination[0]

                commit('SET_LOTTERYUSAGE_TOTALRECORDS', totalRecords)
                commit('SET_LOTTERYUSAGE_TOTALPAGES', +totalPages)

                commit('SET_LOTTERYUSAGE', res.data.data)
                commit('SET_LOTTERYUSAGE_STATUS', 'idle')
            } catch (err) {
                if (!this.$api.isCancel(err)) {
                    commit('SET_LOTTERYUSAGE_STATUS', 'idle')
                }
            }
        },
        async lotteryUsageFiltersFetch({ dispatch }) {
            await dispatch('devicesFetch')
        },
        setLotteryUsageSort({ commit }, payload) {
            commit('SET_LOTTERYUSAGE_SORT', payload)
        }
    },
    getters: {
        getLotteryUsageQueryParams: (state, allGetters) => {
            const paging = {
                direction: state.sort.direction.toLowerCase(),
                sort: state.sort.by,
                page: state.pagination.page,
                per: state.filters.advancedDisplay.value
                    ? state.pagination.perPage
                    : 99999
            }

            const params = { ...paging }

            const { shopIds, startDate, endDate } = state.filters

            if (shopIds.value) {
                Object.assign(params, {
                    merchant_id: state.filters.shopIds.value
                })
            }
            if (startDate.value || endDate.value) {
                let filterDate = ''
                filterDate += startDate.value
                    ? `${startDate.value},`
                    : '2000-01-01,'
                filterDate += endDate.value
                    ? `${endDate.value},`
                    : moment().format('DD-MM-YYYY')

                Object.assign(params, { created_at: filterDate })
            }

            return params
        },
        getLotteryUsage: state => {
            let lotteryUsage

            if (state.filters.advancedDisplay.value) {
                lotteryUsage = state.lotteryUsage
            } else {
                lotteryUsage = []

                const uniqueMerchantIds = state.lotteryUsage
                    .map(usage => usage.merchant.id)
                    .filter((value, index, self) => {
                        return self.indexOf(value) === index
                    })

                uniqueMerchantIds.forEach(merchantId => {
                    const merchantUsages = state.lotteryUsage.filter(
                        usage => usage.merchant.id === merchantId
                    )
                    const totalCodeUsages = merchantUsages.length
                    const totalRefund = merchantUsages
                        .map(usage => parseFloat(usage.refund))
                        .reduce((a, b) => a + b)

                    lotteryUsage.push({
                        lottery: merchantUsages[0].lottery,
                        merchant: merchantUsages[0].merchant,
                        totalCodeUsages,
                        totalRefund
                    })
                })
            }

            return lotteryUsage
        },
        getLotteryUsageStatus: state => {
            return state.status
        },
        getLotteryUsagePagination: state => {
            return state.pagination
        },
        getLotteryUsageFilters: state => {
            return state.filters
        },
        getLotteryUsageSortOptions: state => {
            return state.sortOptions
        },
        getLotteryUsageSort: state => state.sort,
        isLotteryReportAdvancedDisplay: state =>
            state.filters.advancedDisplay.value
    }
}
